import { useMutation } from '@apollo/client/react';
import { CREATE_STRIPE_CHECKOUT_SESSION } from '../queries/CreateStripeCheckoutSession';
import { LoggerContextProps } from '../types/LogContext';
import { handleError } from './errorHandler';

type CreateStripeCheckoutSessionData = {
  createCheckoutSession: {
    url: string;
  };
};

export function useCreateStripeCheckoutSession() {
  const context: LoggerContextProps = {
    action: 'createStripeCheckoutSession',
  };

  const [createStripeCheckoutSession, { data, loading, error }] =
    useMutation<CreateStripeCheckoutSessionData>(CREATE_STRIPE_CHECKOUT_SESSION);

  const createCheckoutSession = async (productId: number) => {
    try {
      const { data } = await createStripeCheckoutSession({
        variables: {
          input: {
            product_id: productId,
          },
        },
      });
      if (data?.createCheckoutSession?.url) {
        window.location.href = data.createCheckoutSession.url;
      }
    } catch (error) {
      handleError(error, context, 'Failed to create checkout session.');
    }
  };

  return { createCheckoutSession, data, loading, error };
}
